import React from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useSaleListModel } from "../saleListModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { IDescription, DescriptionColorEnum } from "@/components/YhBox/Types";

export const DataBox = () => {
    const { exportSaleList, statistics } = useSaleListModel();

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.S_A_EX}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => exportSaleList()}
            >导出</Button>
        </YhAuth>

    </>;

    const desc: IDescription[] = [
        {
            label: "合同数量",
            value: statistics.num,
            color: DescriptionColorEnum.green
        },
        {
            label: "合同总金额",
            value: statistics.amount,
            color: DescriptionColorEnum.red
        }
    ]

    return (
        <YhBox title={action} descriptions={desc}>
            <DataTable />
        </YhBox>
    )
}